<script lang="ts">
  import { onMount } from 'svelte'
  import { LobbyState } from './observables'
  import { filter, switchMap } from 'rxjs/operators'
  import * as api from '../utilities/backendApi'
  import { refresh_claims_token } from '../Users/observables'
  import { db } from '../Firebase'
  import { doc, getDoc } from 'firebase/firestore'

  export let org_uid: string
  const lobbyExistenceCheck = async (): Promise<boolean> => {
    const result = await getDoc(doc(db, 'organizations', org_uid, 'lobby', 'state'))
    return result.exists()
  }
  const lobby_state = LobbyState(org_uid)
  const join_attempt = lobby_state.pipe(
    filter(lobby => lobby.status !== 'Closed'),
    switchMap(async () => api.joinOrganization({ org_uid })),
  )
  onMount(() => {
    const sub = join_attempt.subscribe(response => {
      if (response.status === 'Ok') {
        refresh_claims_token.next(true)
      }
    })
    return () => sub.unsubscribe()
  })
  const lobby_exists = lobbyExistenceCheck()
</script>

{#await lobby_exists}
  <p>Loading...</p>
{:then lobby_exists}
  {#if !lobby_exists}
    <p>That Retro is not joinable. Are you sure you have the correct link?</p>
  {:else if !$lobby_state}
    <p>Loading...</p>
  {:else if $lobby_state.status === 'Full'}
    <p>The Retro is at capacity, ask the leader to review the attendees.</p>
  {:else if $lobby_state.status === 'Closed'}
    <p>Waiting for someone to start the Retro.</p>
  {:else if $lobby_state.status === 'Open'}
    <p>Joining the Retro now...</p>
  {/if}
{/await}
